import React, { useRef, useEffect, useState, InputHTMLAttributes } from 'react';
import { useField } from '@unform/core';
import { FiX } from 'react-icons/fi';

import { Container, Input, ErrorMessage, RemainingChars, Info } from './styles';

interface IProps extends InputHTMLAttributes<HTMLInputElement> {
  name: string;
  icon?: JSX.Element;
  max?: number;
}
const InputField: React.FC<IProps> = ({ name, icon, ...rest }) => {
  const ref = useRef<HTMLInputElement>(null);
  const { fieldName, registerField, defaultValue, error } = useField(name);
  const [count, setCount] = useState(0);
  useEffect(() => {
    registerField({
      name: fieldName,
      ref: ref.current,
      path: 'value',
      setValue: (ref: HTMLInputElement, value: string) => {
        ref.value = value ?? '';
      },
      clearValue: (ref: HTMLInputElement) => {
        ref.value = '';
      },
    });
  }, [fieldName, registerField]);

  // o unform envia undefined como valor inicial e acaba entendendo como string, então no meu Nome Produto, acaba ficando undenfined como 'placeholder'
  return (
    <Container $icon={icon}>
      {!!icon && (
        <div>
          {icon}
          <span />
        </div>
      )}
      <Input
        {...rest}
        $icon={icon}
        name={name}
        defaultValue={defaultValue}
        $error={error}
        ref={ref}
        onChange={e => setCount(e.target.value.length)}
        autoComplete="false"
        maxLength={rest.max}
      />
      {!!error && (
        <i>
          <FiX />
        </i>
      )}

      <Info>
        <ErrorMessage>{error}</ErrorMessage>
        {rest.max && (
          <RemainingChars>
            {count}/{rest.max} caracteres
          </RemainingChars>
        )}
      </Info>
    </Container>
  );
};

export default InputField;
